import { connect } from 'react-redux'
import sections from './items'
import Menu from './index'

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
	menuOpened : state.global.navigationOpened,
	sections,
  pathname: state.router.location.pathname,
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
